import React from 'react';
import DebtClockDigits from 'components/DebtClock/Digits/Digits';
import useDebtClockConfig from 'hooks/useDebtClockConfig';
import styles from './DebtClockLayout.module.css';

function DebtClockLayout({ province, language, debt_data }) {
  const { debtConfigState, MAIN_INTERVAL } = useDebtClockConfig(
    province,
    debt_data
  );

  const currentClock = debt_data ? debt_data[province] : null;
  if (!currentClock) {
    return null;
  }

  const isFrench = String(language || 'en').toLowerCase().startsWith('fr');
  const clock_title = String(
    (isFrench && currentClock.clockTitleFr) ||
      currentClock.clockTitle ||
      province ||
      ''
  ).toUpperCase();
  const share_label = (isFrench ? 'Votre part' : 'Your Share').toUpperCase();
  return (
    <React.Fragment>
      <div className={styles['main-container']}>
        <div
          className={
            styles['debt-clock-container'] + ' ' + styles['gray-border']
          }
        >
          <h1
            className={
              styles['debt-clock-text'] +
              ' ' +
              styles['debt-clock-title'] +
              (clock_title.length > 22
                ? ' ' + styles['debt-clock-title-smaller']
                : '')
            }
          >
            {clock_title}
          </h1>
          <div
            className={
              styles['debt-clock-numbers'] + ' ' + styles['clock-text']
            }
          >
            {debtConfigState.debtMain != null && (
              <DebtClockDigits
                interval={MAIN_INTERVAL}
                initialDebt={debtConfigState.debtMain}
                incrementRate={debtConfigState.incrementRateMain || 0}
                isFederal
                slideUp={(debtConfigState.incrementRateMain || 0) > 0}
              />
            )}
          </div>
        </div>
        <div
          className={styles['debt-clock-share'] + ' ' + styles['gray-border']}
        >
          <h1
            className={
              styles['debt-clock-share-text'] + ' ' + styles['debt-clock-text']
            }
          >
            {share_label}
          </h1>
          <div
            className={
              styles['debt-clock-numbers'] + ' ' + styles['clock-text']
            }
          >
            {debtConfigState.debtShare != null &&
              debtConfigState.population > 0 && (
                <DebtClockDigits
                  interval={MAIN_INTERVAL}
                  initialDebt={debtConfigState.debtShare}
                  incrementRate={debtConfigState.incrementRateShare || 0}
                  isFederal
                  slideUp={(debtConfigState.incrementRateShare || 0) > 0}
                />
              )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default DebtClockLayout;
